<template>
  <form-field-select v-model="sortBy" @change="handleInput">
    <template v-slot:before>
      <p class="sort_by--label">{{ label }}</p>
    </template>

    <option
      v-for="option in sortByOptions"
      :key="option.value"
      :value="option.value"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterBarSortBy",
  props: {
    label: {
      type: String,
      default: "sort by:"
    },
    storeModule: {
      type: String,
      required: true
    },
  },
  computed: {
    sortBy: {
      get() {
        return this.$store.state[this.storeModule].sortBy;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setSortBy", value);
      }
    },
    sortByOptions() {
      return this.$store.state[this.storeModule].sortByEnum;
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.sort_by--label {
  padding-top: 3px;
  padding-right: 10px;
  color: $text-muted;
  font-size: 0.8rem;
  line-height: 1.5rem;
}
</style>
